const defaultFont = {
  alias: 'Helvetica Neue',
  family: 'Helvetica Neue',
  name: 'Helvetica Neue',
}

export default defaultFont
